export default __webpack_public_path__ + "static/media/us-hi.5edec863.svg";